<div class="flex flex-column h-screen">
  <app-header></app-header>
  <app-loading></app-loading>
  <div class="flex-grow-1 surface-200">
    <p-toast></p-toast>
    <router-outlet></router-outlet>
  </div>
</div>
